/**
 * Firebase Configuration - Tô Alugando
 * Push Notifications com Firebase Cloud Messaging
 */
import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Configuração do Firebase — projeto toalugando-22306
const firebaseConfig = {
  apiKey: "AIzaSyBujOfOhJ2DAD7OSV9z3TUJpd04RNm3y98",
  authDomain: "toalugando-22306.firebaseapp.com",
  projectId: "toalugando-22306",
  storageBucket: "toalugando-22306.firebasestorage.app",
  messagingSenderId: "348144965861",
  appId: "1:348144965861:web:756d2b7e5dc3956e36dc0c",
  measurementId: "G-1D4D3ESR0R"
};

// VAPID Key para Web Push (projeto toalugando-22306)
const VAPID_KEY = "BDfKst8qq1d0aSJgvnXHT90iim-_jPMUyXMXDCawZrEVNjVAs4m3Y-EIDeL4fzWjH8jKLKdcnS5Wb3U21eYZPoE";

// Inicializar Firebase (singleton)
let firebaseApp = null;
let messaging = null;

export function getFirebaseApp() {
  if (firebaseApp) return firebaseApp;
  
  if (getApps().length > 0) {
    firebaseApp = getApps()[0];
  } else {
    firebaseApp = initializeApp(firebaseConfig);
  }
  
  return firebaseApp;
}

export function getFirebaseMessaging() {
  if (messaging) return messaging;
  
  // Verificar se o navegador suporta notificações
  if (!('Notification' in window)) {
    console.warn('Este navegador não suporta notificações');
    return null;
  }
  
  // Verificar se service workers são suportados
  if (!('serviceWorker' in navigator)) {
    console.warn('Este navegador não suporta Service Workers');
    return null;
  }
  
  try {
    const app = getFirebaseApp();
    messaging = getMessaging(app);
    return messaging;
  } catch (error) {
    console.error('Erro ao inicializar Firebase Messaging:', error);
    return null;
  }
}

/**
 * Solicita permissão e obtém o token FCM
 * @returns {Promise<string|null>} Token FCM ou null se não autorizado
 */
export async function requestNotificationPermission() {
  try {
    // Verificar permissão atual
    const permission = await Notification.requestPermission();
    
    if (permission !== 'granted') {
      console.log('Permissão de notificação negada');
      return null;
    }
    
    // Registrar service worker se necessário
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log('Service Worker registrado:', registration.scope);
    
    // Obter token
    const messagingInstance = getFirebaseMessaging();
    if (!messagingInstance) return null;
    
    const token = await getToken(messagingInstance, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });
    
    if (token) {
      console.log('Token FCM obtido:', token.substring(0, 20) + '...');
      return token;
    } else {
      console.log('Não foi possível obter token FCM');
      return null;
    }
    
  } catch (error) {
    console.error('Erro ao solicitar permissão:', error);
    return null;
  }
}

/**
 * Configura listener para notificações em foreground
 * @param {Function} callback Função chamada quando notificação chega
 */
export function onForegroundMessage(callback) {
  const messagingInstance = getFirebaseMessaging();
  if (!messagingInstance) return () => {};
  
  return onMessage(messagingInstance, (payload) => {
    console.log('Notificação recebida (foreground):', payload);
    callback(payload);
  });
}

/**
 * Verifica se as notificações estão habilitadas
 */
export function isNotificationSupported() {
  return 'Notification' in window && 'serviceWorker' in navigator;
}

/**
 * Verifica o status atual da permissão
 */
export function getNotificationPermissionStatus() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission; // 'granted', 'denied', 'default'
}

export default {
  getFirebaseApp,
  getFirebaseMessaging,
  requestNotificationPermission,
  onForegroundMessage,
  isNotificationSupported,
  getNotificationPermissionStatus
};
